<template lang="pug">
  v-container
    v-row( wrap)
      v-col(cols="12" lg="4")
        v-card.text-center
          .info-tender__administra Administra
          v-divider
          .info-tender__description Ten el control de tu Negocio desde la comodidad de tu hogar
          v-expansion-panels.mt-2
            v-expansion-panel(v-for=" (i, index) in features_empresas" @click="slideFeature(index)")
              v-expansion-panel-header(disable-icon-rotate).justify-self-start
                div
                  v-icon(size='35' color="primary") mdi-star
                  span.info-tender__item {{i.name}}
              v-expansion-panel-content.text-justify
                | {{i.description}}
      //- v-col(cols="12" lg="4" style="height: 700px; z-index: 1; position: relative;").screen-carousel
        v-img(:src="screener3"  style="position:absolute;").screen-carousel__screener
          v-carousel( v-model='current_feature' vertical  height='650px'  :cycle="cycle" hide-delimiters hide-delimiter-background show-arrows-on-hover).mt-6.screen-carousel__container
            v-carousel-item(  reverse-transition='fade-transition' transition="fade-transition"  v-for="(screen, i) in screens" :key="i" )
              v-img(contain :src="screen.src" height="560px" width="375px; z-index: -2;")
      v-col(cols="12" lg="4")
        v-card.text-center
          .info-tender__vende Vende
          v-divider
          .info-tender__description Impulsa tus ventas en la nueva economia a distancia
          v-expansion-panels.mt-2
            v-expansion-panel(v-for=" (i, index) in features_pos" @click="slideFeature(index + 5)")
              v-expansion-panel-header(disable-icon-rotate).justify-self-start
                div
                  v-icon(size='35' color="primary") mdi-star
                  span.info-tender__item {{i.name}}
              v-expansion-panel-content.text-justify
                | {{i.description}}
</template>

<script>
  export default {
    name: 'FeatureCarousel',
    data: () => ({
      current_feature: 0,
      features_empresas: [
        {
          name: 'Gestiona inventario',
          description: 'Asigna cantidades y precios a tus productos, descuenta inventario por venta, controla tus margenes de  utilidad.',
        },
        {
          name: 'Gestiona tus movimientos',
          description: 'Accede a tu historial de ventas y comprobantes, compras, traslados, ordenes, gastos y devoluciones,',
        },
        {
          name: 'Observa tu crecimiento',
          description: 'Genera reportes de tus indicadores de crecimiento, tus ordenes a la tienda virtual, tus productos mas Vendidos, y tu utilidad Neta',
        },
        {
          name: 'Gestiona tu Equipo de Ventas',
          description: 'Crea Colaboradores y Vendedores para que hagan ventas en Punto Virtual o en Punto Físico.',
        },

      ],
      features_pos: [
        {
          name: 'Vende en tu Punto de venta (POS)',
          description: 'Genera Facturas de Venta, Gestiona en Tiempo Real tus Unidades Disponibles, Recibe Pedidos, Atiende a tus Clientes con Nuestro POS',
        },
        {
          name: 'Comparte tu Tienda virtual',
          description: 'Comparte tu enlace personalizado entre tus clientes para que te hagan pedidos por tu tienda Virtual',
        },
        {
          name: 'Fideliza a tus clientes',
          description: 'Enviales promociones, y cupones de descuento',
        },
        {
          name: 'Gestiona Pedidos',
          description: 'Indica los estados de los pedidos que recibas, procesalos, para que tus clientes sepan el estado de sus pedidos, mantente conectado con ellos',
        },
        {
          name: 'Personaliza tus ventas',
          description: 'Usa el Sistema de Venta Personalizada, lleva tus ventas a otro Nivel con el Carrito de Compras Asistido, Muestrale a tus clientes , tus productos en tiempo Real',
        },
      ],
    }),

    methods: {
      slideFeature (num) {
        this.cycle = false
        // console.log(num)
        this.current_feature = num
      },
    },
  }
</script>
<style lang="scss">

</style>
